import React, { useState } from "react";
import { StyledSidebar } from "../styles/styledComponents";
import CheckIcon from '../components/CheckIcon';
import {useTranslation} from "react-i18next";
import { Link } from "react-scroll";

type SidebarProps = {
 
  productSectionDone: boolean;
  mountedSectionDone: boolean;
  colorSectionDone: boolean;
  hideMounted: boolean;
};

const Sidebar = (props: SidebarProps) => {
  const { productSectionDone, mountedSectionDone, colorSectionDone, hideMounted } = props;
  const [activeSection, setActiveSection] = useState(0);

  const {t} = useTranslation('trans');

  return (
    <StyledSidebar className="App-navigation">
      
    <Link
       activeClass="Active" className="section1" to="section1" spy={true} smooth={true} duration={500} offset={-490} onSetActive={() => setActiveSection(1)}
      >
        1. {t('selectTitles.product').toUpperCase()}
        <CheckIcon size="lg" display={productSectionDone && activeSection !== 1} />
      </Link>
      {!hideMounted &&
      <Link activeClass="Active" className="section2" to="section2" spy={true} smooth={true} duration={500} offset={-450} onSetActive={() => setActiveSection(2)}>
      2. {t('selectTitles.mounted').toUpperCase()}
        <CheckIcon size="lg" display={mountedSectionDone && activeSection !== 2} />
      </Link>
}
      <Link
        activeClass="Active" className="section3" to="section3" spy={true} smooth={true} duration={500} offset={-450}  onSetActive={() => setActiveSection(3)}
      >
       {hideMounted ? '2.' : '3.'}  {t('selectTitles.color').toUpperCase()}
        <CheckIcon size="lg" display={colorSectionDone && activeSection !== 3} />
      </Link>
      <Link
       activeClass="Active" className="section4" to="section4" spy={true} smooth={true} duration={500} offset={-450}  onSetActive={() => setActiveSection(4)}
      >
        {hideMounted ? '3.' : '4.'} {t('selectTitles.measure').toUpperCase()}
      </Link>

    </StyledSidebar>
  );
};

export default Sidebar;
